var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_vm.project.name ? _c('h3', [_vm._v("Project: " + _vm._s(_vm.project.name))]) : _vm._e(), _c('project-card', {
    attrs: {
      "project": _vm.project,
      "projectRelease": _vm.projectRelease
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }